var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-modal"},[_c('video',{staticClass:"landing-modal__video",attrs:{"controls":"controls","autoplay":""}},[_c('source',{attrs:{"src":"https://storage.yandexcloud.net/onti-public/media/NTO_start_2023.mp4","type":"video/mp4"}})])])
}]

export { render, staticRenderFns }